module.exports = __webpack_public_path__ + "static/media/comment-alt.3756a85c.png";